const videoUri = {
    upload: "files/upload-video",
    save: "videos",
    search: "videos/search",
    delete: "videos/{id}",
    update: "videos/{videoUid}",
    streamStatus: "files/video-stream/{videoUid}"
};

export default videoUri;
